import { createTabs } from "./createTabs.mjs";
import { DefaultTabsContentFrame, DefaultTabsFrame, DefaultTabsTabFrame } from "./Tabs.mjs";
export * from "./createTabs.mjs";
export * from "./StyledContext.mjs";
const Tabs = createTabs({
  ContentFrame: DefaultTabsContentFrame,
  TabFrame: DefaultTabsTabFrame,
  TabsFrame: DefaultTabsFrame
});
export { Tabs };
//# sourceMappingURL=index.mjs.map
